<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9qhZBr/tc-custom/9781526795793.jpg?1712387828656" alt="This image is the cover for the book Carmarthen to Fishguard Harbour"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Carmarthen to Fishguard Harbour
      </h1>
      <p class="bookDescription body article font2">
        <p>This volume covers the important main line section of line between Carmarthen and Fishguard Harbour, the terminus station opening in 1906 and replacing New Milford (later Neyland) as the previous main line terminus. In 1909 Cunard passenger liners between New York and Liverpool began calling at Fishguard and this book contains a fascinating account of this working lasting 3-4 years which saw fast connecting trains running to Paddington and the Continent via Dover. There were also important branches coming off this line at Whitland (for Pembroke Dock) and also to Cardigan, though the latter was closed in the Beeching cuts of 1964. The book affords a detailed look at Whitland where the rail service has been completely transformed since the end of steam. We see the Milk services that ran from Whitland (as well as Carmarthen) and the Fish services from Milford Haven, as well as the Oil Trains which will feature in a later volume.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Hodge
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Transport
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4e621db4